import React from "react";
import tw from "tailwind-styled-components";
import Model from "../Model";
import moment from "moment";
import Config from "../../Config";

import {
  SubmitBtn,
  OtherBtn,
  CancelBtn
} from "../Styles/InputStyles";

const AdminLCModal = ({ setAdminLCModel, selectedItem, serviceType, apiData, generateCertificateMutate }) => {
  // console.log("apiData", apiData);
  return (
    <Model width={"w-8/12 max-w-lg"} setOpenModel={setAdminLCModel}>
      <Wrapper>
        <Title>Lost Certificate Details</Title>
        <SingleItem name={"Association Name"} value={apiData.assocName || "XYZ"} />
        <SingleItem name={"Association Made On"} value={apiData.assocCertifyDate || selectedItem.date} />
        <SingleItem name={"Payment Status"} value={apiData.paymentStatus || "Paid"} />
        <SingleItem name={"Amount"} value={(apiData.amount + " TZS")} />
        <SingleItem name={"User Remarks"} value={apiData.lostCertificateRemarks } />
        {apiData.lostCertificateReport && 
          <SingleItem name={"Report"} value={ 
          <LinkValue>
          <a  href= {(Config.certificateUrl + selectedItem.id + "/" + apiData.lostCertificateReport )} target="_blank">Lost Certificate Report</a>
          </LinkValue>} />
        }
      </Wrapper>
      <BtnWrapper>
          <SubmitBtn onClick={() => generateCertificateMutate(selectedItem)}>Generate Certificate</SubmitBtn>
      </BtnWrapper>
    </Model>
  );
};

const SingleItem = ({ name, value, link, url }) => (
  <div className="flex items-center py-2 border-b border-gray-100 ">
    <Name>{name}</Name> <p className="w-10">:</p>
    {link && (
      <LinkValue href={url} target="_blank" title="Click to open">
        {value}
      </LinkValue>
    )}
    {!link && <Value>{value}</Value>}
  </div>
);

const Wrapper = tw.div`px-4`;
const Title = tw.h2`text-lg md:text-xl mb-6 text-gray-700 font-medium text-left`;
const Name = tw.p`text-sm text-gray-500  w-40`;
const Value = tw.p`text-sm text-gray-800 font-medium max-w-xs `;
const LinkValue = tw.a`text-sm text-blue-500 max-w-xs truncate cursor-pointer`;
const BtnWrapper = tw.div` w-full flex items-center justify-end space-x-10 mt-8`;

export default AdminLCModal;
